<template>
<main>

    <section id="uebermich" aria-label="&Uuml;ber mich">
      <div class="blue-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <h1>BIO</h1>
            </div>
             
            <div>
              <img src="../assets/img/home/sabine2.png" alt="">
            </div>
          <!-- </div> -->
        </div>
      </div>
    </section>

  </main>

</template>

<script>

import Slider from "./shared/Slider.vue";

export default {
  name: "Bio", //this is the name of the component


  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
 metaInfo() {
        return { 
            title: "Pferdeverstand - Sabine Döbrössy",
            meta: [
              { name: 'description', content: 'Pferdeverstand.at - Training und Gesundheit für Reiter und Pferd' },
              { property: 'og:title', content: "Pferdeverstand.at - für alle, die mit ihrem Pferd weiterkommen wollen."},
              { property: 'og:description', content: 'Training und Gesundheit für Reiter und Pferd'},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
              { property: 'og:url', content: 'www.pferdeverstand.at'}
            ]
        }
}
// TODO meta
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Bio.vue